import React from 'react';
import { getPropertiesFromFeature } from '../../../../../utils/driverUtils';
import { Card } from 'react-bootstrap';
import TuningFactor from './projectProperties/TuningFactor';
import CurrentSetting from './projectProperties/CurrentSetting';
import ConstantLumen from './projectProperties/ConstantLumen';
import DaliSetting from './projectProperties/DaliSetting';
import SoftSwitchOff from './projectProperties/SoftSwitchOff';
import DimToDark from './projectProperties/DimToDark';
import SolarChargeController from './projectProperties/SolarChargeController';
import Emergency from './projectProperties/Emergency';
import EndOfLife from './projectProperties/EndOfLife';
import OperatingTime from './projectProperties/OperatingTime';
import DriverGuard from './projectProperties/DriverGuard';
import LuminaireInfo from './projectProperties/LuminaireInfo';
import ConfigurationLock from './projectProperties/ConfigurationLock';
import TouchDim from './projectProperties/TouchDim';
import Corridor from './projectProperties/Corridor';
import ThermalProtection from './projectProperties/ThermalProtection';
import StepDim from './projectProperties/StepDim';

import UndevelopedFeature from './projectProperties/UndevelopedFeature';
import AstroDim from './projectProperties/AstroDim';
import DimmingModes from './projectProperties/DimmingModes';
import DexalPSU from './projectProperties/DexalPSU';
import MainsDIM from './projectProperties/MainsDIM';
import PresenceDetection from './projectProperties/PresenceDetection';
import SensorMode from './projectProperties/SensorMode';
import MultipleOutputCurrent from './projectProperties/MultipleOutputCurrent';
import LedModule from './projectProperties/LedModule';
import ZeroToTen from './projectProperties/ZeroToTen';
import DaliTW from './projectProperties/DaliTW';
import DaliAddressing from './projectProperties/DaliAddressing';
import DimToWarm from './projectProperties/DimToWarm';
import RGBWAF from './projectProperties/RGBWAF';
import ChannelControl from './projectProperties/ChannelControl';
import PermanentShutdown from './projectProperties/PermanentShutdown';
import Dimming from './projectProperties/Dimming';
import PowerOnDelay from './projectProperties/PowerOnDelay';
import Diagnostics from './projectProperties/Diagnostics';
import Repeater from './projectProperties/Repeater';
import PwmDimMode from './projectProperties/PwmDimMode';
import AdjustableDim from './projectProperties/AdjustableDim';
import PWMDim from './projectProperties/PWMDim';
import DigitalDim from './projectProperties/DigitalDim';
import DimSettings from './projectProperties/DimSettings';
import DipSwitchCurrentSettings from './projectProperties/DipSwitchCurrentSettings';
import LightSensor from './projectProperties/LightSensor';
import AntiFlicker from './projectProperties/AntiFlicker';

import LegalText from './LegalText';

import { Button } from 'react-bootstrap';
import { Link } from 'lucide-react';

import {
    ASTRO_DIM,
    CONFIGURATION_LOCK,
    CONSTANT_LUMEN_OUTPUT,
    DALI_DEXAL_SETTINGS,
    DIM_TO_DARK,
    SOLAR_CHARGE_CONTROLLER,
    DRIVER_GUARD,
    EMERGENCY_MODE,
    END_OF_LIFE,
    LAMP_OPERATING_TIME,
    LUMINAIRE_INFO,
    OPERATING_CURRENT,
    SOFT_SWITCH_OFF,
    STEP_DIM,
    THERMAL_PROTECTION,
    TOUCH_DIM_AND_SENSOR,
    CORRIDOR,
    TUNING_FACTOR,
    DIMMING_MODES,
    DEXAL_POWER_SUPPLY_UNIT,
    MAINS_DIM,
    PRESENCE_DETECTION,
    MULTIPLE_OUTPUT_CURRENT,
    LED_MODULE,
    ZERO_TO_TEN,
    DALI_DT8_TW_SETTINGS,
    DIM_TO_WARM,
    DALI_ADDRESSING,
    RGBW,
    CHANNEL_CONTROL,
    PERMANENT_SHUTDOWN,
    DIMMING,
    ASTRO_DIM8,
    STEP_DIM8,
    PRESENCE_DETECTION8,
    POWER_ON_DELAY,
    DIAGNOSTICS,
    REPEATER,
    PWM_DIM_MODE,
    ASTRO_DIM_TW,
    ASTRO_DIM_10,
    ADJUSTABLE_DIM,
    PWM_DIM,
    DIGITAL_DIM,
    DIM_SETTINGS,
    DIP_SETTINGS,
    LIGHT_SENSOR,
    ANTI_FLICKER,
    PULL_UP_CURRENT,
    SENSOR_MODE,
    ASTRO_DIM_SENSOR,
    SOFT_START,
    MLS_MULTI_LUM,
    ASTRO_DIM_5
} from '../../../../../utils/constantFeatures';
import AstroDimTW from './projectProperties/AstroDimTW';
import AstroDim10 from './projectProperties/AstroDim10';
import AstroDimSensor from './projectProperties/AstroDimSensor';
import FadeSettings from './projectProperties/FadeSettings';
import AuxSettings from './projectProperties/AuxSettings';
import PullUpCurrent from './projectProperties/PullUpCurrent';
import SoftStart from './projectProperties/SoftStart';
import MultiLumSettings from './projectProperties/MultiLumSettings';
import AstroDim5 from "./projectProperties/AstroDim5";
export default class ProjectFeature extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            properties: null,
            channelSelected: ['0'],
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeExtraProperties = this.handleChangeExtraProperties.bind(this);
        // this.handlePropertyCheckboxChange = this.handlePropertyCheckboxChange.bind(this);
        // this.handlePropertyPickerChange = this.handlePropertyPickerChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {

        if (props.feature && props.properties) {
            return {
                properties: getPropertiesFromFeature(props.feature, props.properties)
            };
        }

        return null;
    }

    handleChange(propertyName, value) {

        this.state.channelSelected.forEach((indexOfChannel) => this.changeProperty(indexOfChannel, propertyName, value));
    }

    changeProperty(indexOfChannel, propertyName, value) {
        //Edit name for multichannel properties
        const indexOfUnderscore = propertyName.indexOf("_");
        const name = indexOfUnderscore === -1 ? propertyName : propertyName.substring(0, indexOfUnderscore);

        //let property = this.state.properties[`ch_${indexOfChannel}`][propertyName];
        let property = this.state.properties[`ch_${indexOfChannel}`][name];
        property.value = value;

        this.props.handleChangeDriverProperties(property);

        this.setState(function (state) {
            //state.properties[`ch_${indexOfChannel}`][propertyName].value = value;
            state.properties[`ch_${indexOfChannel}`][name].value = value;
            return state;
        });
    }

    addExtraProperties(names) {

        const returnValue = {};

        this.props.properties.forEach((property) => {

            const indexOfUnderscore = property.info.name.indexOf("_");
            if (indexOfUnderscore === -1) {
                if (names.indexOf(property.info.name) !== -1) {
                    returnValue[property.info.name] = property;
                } else {
                    return;
                }
            }

            const name = indexOfUnderscore >= 0 ? property.info.name.substring(0, indexOfUnderscore) : property.info.name;
            if (names.indexOf(name) === -1) {
                return;
            }

            const indexOfChannel = property.info.name.substring(indexOfUnderscore + 1, property.info.name.length);
            if (this.state.channelSelected.indexOf(indexOfChannel) !== -1) {
                returnValue[name] = property;
            } else {
                return;
            }
        });

        return returnValue
    }

    handleChangeExtraProperties(property) {
        this.props.handleChangeDriverProperties(property);
    }

    handleChangeChannelSelector(indexes) {

        // We are connecting the channels
        // We have to send to the other channel all the properties of the actual one
        if (indexes.length > 1) {
            for (var i = 0; i < indexes.length; i++) {
                if (this.state.channelSelected.indexOf(indexes[i]) >= 0) {
                    continue;
                }

                const props = Object.values(this.state.properties[`ch_${this.state.channelSelected[0]}`]);
                for (var j = 0; j < props.length; j++) {
                    this.changeProperty(indexes[i], props[j].info.name, props[j].value)
                }
            }
        }

        this.setState({ channelSelected: indexes });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if(this.props.feature?.disabledChannels){
            if (this.props.feature && this.props.feature.instanceCount === 2){
                if(this.props.feature.disabledChannels.includes(0) && prevState.channelSelected.indexOf('0') !== -1) {
                    this.handleChangeChannelSelector(['1']);
                } else if(this.props.feature?.disabledChannels.includes(1) && prevState.channelSelected.indexOf('1') !== -1){
                    this.handleChangeChannelSelector(['0']);
                }
            }
        }

        if (this.props.feature && this.props.feature.instanceCount < 2 && prevState.channelSelected.indexOf('1') !== -1) {
            this.setState({ 'channelSelected': ['0'] });
        }

        // Check if both channel are equals
        if (this.state.properties !== null && Object.keys(this.state.properties).length > 1) {
            if (this.props.feature && this.props.feature !== prevProps.feature) {
                const keys = Object.keys(this.state.properties[`ch_0`]);
                let areTheyEqual = [];
                for (var i = 0; i < keys.length; i++) {
                    if (this.state.properties[`ch_0`][keys[i]]?.value !== this.state.properties[`ch_1`][keys[i]]?.value) {
                        // this.setState({'channelSelected': ['0']});
                        areTheyEqual.push(false);
                    } else {
                        // this.setState({'channelSelected': ['0', '1']});
                        areTheyEqual.push(true);
                    }
                }
                if (areTheyEqual.length > 0 && areTheyEqual.every(v => v === true)) {
                    this.setState({ 'channelSelected': ['0', '1'] });
                } else {
                    this.setState({ 'channelSelected': ['0'] });

                }
            }
        }
    }

    render() {

        if (!this.props.feature || !this.props.properties || !this.state || !this.state.properties) {
            return null;
        }
        //const components = this.getComponentsFromFeature(this.props.feature, this.state.properties);

        const properties = this.state.properties[`ch_${this.state.channelSelected[0]}`] ?? this.state.properties[`ch_0`];

        const channelSelectorComponent = this.props.feature.instanceCount > 1 ?
            (<div className="center" style={{ margin: '0 auto 1.25rem' }}>
                <Button
                    hidden={this.props.feature?.disabledChannels && this.props.feature.disabledChannels.includes('0')}
                    disabled={this.props.feature?.disabledChannels && this.props.feature.disabledChannels.includes('0')}
                    variant={this.state.channelSelected.indexOf('0') !== -1 ? 'primary' : 'secondary'}
                    value={'0'}
                    className="edit-icon-project-header"
                    onClick={(e) => this.handleChangeChannelSelector([e.target.value])}>
                    {'Channel 1'}
                </Button>
                <Link className="close-icon-project-header"
                    hidden={this.props.feature?.disabledChannels}
                    disabled={this.props.feature?.disabledChannels}
                    style={this.state.channelSelected.indexOf('0') !== -1 && this.state.channelSelected.indexOf('1') !== -1 ? { color: '#FF6600' } : {}}
                    onClick={(e) => this.handleChangeChannelSelector(['0', '1'])} />
                {/* onClick={this.props.feature?.disabledChannels ? null : (e) => this.handleChangeChannelSelector(['0', '1'])} /> */}

                <Button
                    hidden={this.props.feature?.disabledChannels && this.props.feature.disabledChannels.includes('1')}
                    disabled={this.props.feature?.disabledChannels && this.props.feature.disabledChannels.includes('1')}
                    variant={this.state.channelSelected.indexOf('1') !== -1 ? 'primary' : 'secondary'}
                    className="edit-icon-project-header"
                    value={'1'}
                    onClick={(e) => this.handleChangeChannelSelector([e.target.value])}>
                    {'Channel 2'}
                </Button>
            </div>)
            : null;

        let featureComponent = null;
        let warningComponent = null;

        switch (this.props.feature.name) {
            case ASTRO_DIM.shortName: {
                featureComponent = <AstroDim
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    extraProperties={this.addExtraProperties([ASTRO_DIM8.initialColour, ASTRO_DIM8.outputColour1, ASTRO_DIM8.outputColour2, ASTRO_DIM8.outputColour3, ASTRO_DIM8.outputColour4, ASTRO_DIM8.outputColour5 ])}
                    driverFeatures={this.props.driverFeatures}
                    handleChange={this.handleChange}
                    handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            case CONFIGURATION_LOCK.shortName: {
                const servicePasswordAvailable = this.props.feature.properties.filter((p) => p.info.name === 'key.sp').length > 0;
                featureComponent = <ConfigurationLock
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case CONSTANT_LUMEN_OUTPUT.shortName: {
                featureComponent = <ConstantLumen
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DALI_DEXAL_SETTINGS.shortName: {
                featureComponent = <DaliSetting
                    feature={this.props.feature}
                    properties={properties}
                    extraProperties={this.addExtraProperties([DALI_DT8_TW_SETTINGS.powerOnColourTemperature, DALI_DT8_TW_SETTINGS.systemFailureColourTemperature])}
                    isTW={this.props.isTW}
                    opModeName={this.props.opModeName}
                    driverFeatures={this.props.driverFeatures}
                    handleChange={this.handleChange}
                    handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            // The solar charge controller of MPPT drivers. Operating-mode independent:
            // it is present whenever the driver carries an MPPTData SubDevice.
            case SOLAR_CHARGE_CONTROLLER.shortName: {
                featureComponent = <SolarChargeController
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DIM_TO_DARK.shortName: {
                featureComponent = <DimToDark
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DIM_TO_WARM.shortName: {
                featureComponent = <DimToWarm
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DRIVER_GUARD.shortName: {
                featureComponent = <DriverGuard
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case EMERGENCY_MODE.shortName: {
                featureComponent = <Emergency
                    feature={this.props.feature}
                    properties={properties}
                    extraProperties={this.addExtraProperties([DALI_DEXAL_SETTINGS.dimmingCurve])}
                    handleChange={this.handleChange} />
                break;
            }
            case ANTI_FLICKER.shortName: {
                featureComponent = <AntiFlicker
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case END_OF_LIFE.shortName: {
                featureComponent = <EndOfLife
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            } case LAMP_OPERATING_TIME.shortName: {
                featureComponent = <OperatingTime
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case LUMINAIRE_INFO.shortName: {
                featureComponent = <LuminaireInfo
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case OPERATING_CURRENT.shortName: {
                //featureComponent = null;

                featureComponent = <CurrentSetting
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case SOFT_SWITCH_OFF.shortName: {
                featureComponent = <SoftSwitchOff
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case STEP_DIM.shortName: {
                featureComponent = <StepDim
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    extraProperties={this.addExtraProperties([STEP_DIM8.stepDimColor1, STEP_DIM8.stepDimColor2, STEP_DIM8.stepDimColor3])}
                    driverFeatures={this.props.driverFeatures}
                    handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            case THERMAL_PROTECTION.shortName: {
                featureComponent = <ThermalProtection
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case TOUCH_DIM_AND_SENSOR.shortName: {
                featureComponent =
                    <TouchDim
                        feature={this.props.feature}
                        properties={properties}
                        extraProperties={this.addExtraProperties([DALI_DEXAL_SETTINGS.dimmingCurve, DALI_DEXAL_SETTINGS.maximum, DALI_DEXAL_SETTINGS.minimum])}
                        handleChange={this.handleChange}
                        handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            case CORRIDOR.shortName: {
                featureComponent =
                    <div>
                        <Corridor
                            feature={this.props.feature}
                            properties={properties}
                            extraProperties={this.addExtraProperties([DALI_DEXAL_SETTINGS.dimmingCurve, DALI_DEXAL_SETTINGS.maximum, DALI_DEXAL_SETTINGS.minimum])}
                            handleChange={this.handleChange}
                            handleChangeExtraProperties={this.handleChangeExtraProperties} />
                    </div>
                break;
            }
            case TUNING_FACTOR.shortName: {
                featureComponent = <TuningFactor
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                warningComponent = <LegalText text={"Use this functionality to limit the Light Output using the T4T Field App. Don't forget to update the access rights with the Configuration Lock"} />
                break;
            }
            case DIMMING_MODES.shortName: {
                featureComponent = <DimmingModes
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DEXAL_POWER_SUPPLY_UNIT.shortName: {
                featureComponent = <DexalPSU
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case MAINS_DIM.shortName: {
                featureComponent = <MainsDIM
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case PRESENCE_DETECTION.shortName: {
                featureComponent = <PresenceDetection
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    extraProperties={this.addExtraProperties([PRESENCE_DETECTION8.presenceDetectionColor])}
                    driverFeatures={this.props.driverFeatures}
                    handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            case SENSOR_MODE.shortName: {
                featureComponent = <SensorMode
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case ASTRO_DIM_SENSOR.shortName: {
                featureComponent = <AstroDimSensor
                    feature={this.props.feature}
                    properties={properties}
                    extraProperties={this.addExtraProperties([
                        ASTRO_DIM_5.submode, ASTRO_DIM_5.switchOnFadeTime, ASTRO_DIM_5.astroDimFadeTime, ASTRO_DIM_5.switchOffFadeTime,
                        ASTRO_DIM_5.outputLevel1, ASTRO_DIM_5.outputLevel2, ASTRO_DIM_5.outputLevel3, ASTRO_DIM_5.outputLevel4, ASTRO_DIM_5.outputLevel5,
                        ASTRO_DIM_5.outputLevel6, ASTRO_DIM_5.outputLevel7, ASTRO_DIM_5.outputLevel8, ASTRO_DIM_5.outputLevel9, ASTRO_DIM_5.outputLevel10,
                        ASTRO_DIM_5.time2, ASTRO_DIM_5.time3, ASTRO_DIM_5.time4, ASTRO_DIM_5.time5, ASTRO_DIM_5.time6,
                        ASTRO_DIM_5.time7, ASTRO_DIM_5.time8, ASTRO_DIM_5.time9, ASTRO_DIM_5.time10
                    ])}
                    handleChange={this.handleChange}
                    handleChangeExtraProperties={this.handleChangeExtraProperties} />
                break;
            }
            case MULTIPLE_OUTPUT_CURRENT.shortName: {
                featureComponent = <MultipleOutputCurrent
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case LED_MODULE.shortName: {
                featureComponent = <LedModule
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case ZERO_TO_TEN.shortName: {
                featureComponent = <ZeroToTen
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DALI_ADDRESSING.shortName: {
                featureComponent = <DaliAddressing
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DALI_DT8_TW_SETTINGS.shortName: {
                featureComponent = <DaliTW
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case RGBW.shortName: {
                featureComponent = <RGBWAF
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case CHANNEL_CONTROL.shortName: {
                featureComponent = <ChannelControl
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case PERMANENT_SHUTDOWN.shortName: {
                featureComponent = <PermanentShutdown
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DIMMING.shortName: {
                featureComponent = <Dimming
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case POWER_ON_DELAY.shortName: {
                featureComponent = <PowerOnDelay
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case DIAGNOSTICS.shortName: {
                featureComponent = <Diagnostics
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case REPEATER.shortName: {
                featureComponent = <Repeater
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case PWM_DIM_MODE.shortName: {
                featureComponent = <PwmDimMode
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case ASTRO_DIM_TW.shortName: {
                featureComponent = <AstroDimTW
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case ASTRO_DIM_10.shortName: {
                featureComponent = <AstroDim10
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case ASTRO_DIM_5.shortName: {
                // In astdimsens mode, AstroDimSensor already renders the Astro-5 schedule
                // (via extraProperties) alongside the sensor settings - don't show it twice.
                if (this.props.opModeName !== ASTRO_DIM_SENSOR.shortName) {
                    featureComponent = <AstroDim5
                        project={this.props.project}
                        driver={this.props.driver}
                        feature={this.props.feature}
                        properties={properties}
                        handleChange={this.handleChange}
                        //driverFeatures={this.props.driverFeatures}
                    />
                }
                break;
            }
            case ADJUSTABLE_DIM.shortName: {
                featureComponent = <AdjustableDim
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case PWM_DIM.shortName: {
                featureComponent = <PWMDim
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case DIGITAL_DIM.shortName: {
                featureComponent = <DigitalDim
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case DIM_SETTINGS.shortName: {
                featureComponent = <DimSettings
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case DIP_SETTINGS.shortName: {
                featureComponent = <DipSwitchCurrentSettings
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case LIGHT_SENSOR.shortName: {
                featureComponent = <LightSensor
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case "fset": {
                featureComponent = <FadeSettings
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case PULL_UP_CURRENT.shortName: {
                featureComponent = <PullUpCurrent
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case "aux": {
                featureComponent = <AuxSettings
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                    //driverFeatures={this.props.driverFeatures}
                />
                break;
            }
            case SOFT_START.shortName: {
                featureComponent = <SoftStart
                    project={this.props.project}
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                />
                break;
            }
            case MLS_MULTI_LUM.shortName: {
                featureComponent = <MultiLumSettings
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange}
                />
                break;
            }
            default: {
                break;
            }
        }

        if (featureComponent) {
            return (
                <div>
                    <Card className="card-body-feature-component">
                        <Card.Body className="card-body-project-feature-component">
                            {channelSelectorComponent}
                            {featureComponent}
                            {warningComponent}
                        </Card.Body>
                    </Card>
                </div>
            );
        }
        else {
            return (
                <div>
                    <Card className="card-body-feature-component">
                        <Card.Body className="card-body-project-feature-component">
                            {channelSelectorComponent}
                            <UndevelopedFeature
                                project={this.props.project}
                                driver={this.props.driver}
                                feature={this.props.feature}
                                properties={properties}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
            );
        }
    }
}
